import { Component, Injector, Input, OnInit, Optional } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  FormGroup,
  NgControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { FormControl } from '@ngneat/reactive-forms';

@Component({
  selector: 'bs-retirada',
  templateUrl: './retirada.component.html',
  styleUrls: ['./retirada.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RetiradaComponent,
      multi: true,
    },
  ],
})
export class RetiradaComponent implements OnInit, ControlValueAccessor {
  ngControl!: NgControl | null;
  retiradaImediataControl = new FormControl(false);
  value!: boolean;
  disabled?: boolean

  @Input() isEditable: boolean = false;

  constructor(
    private readonly injector: Injector,
    @Optional() private readonly controlContainer: ControlContainer
  ) { }

  ngOnInit(): void {
    this.retiradaImediataControl.valueChanges.subscribe((value) => {
      this.onChange?.apply(this, [value]);
      // this.writeValue(value);
    });

    this.ngControl = this.injector.get(NgControl, null);

    if (this.ngControl && this.ngControl.control) {
      this.retiradaImediataControl.validator = this.ngControl.control.validator;
    }

    const hasControl = this.controlContainer && this.controlContainer.control;

    if (!hasControl && this.controlContainer) {
      const formGroup = this.controlContainer.control as FormGroup;
      const key = this.ngControl!.name as keyof FormGroup;
      const control = formGroup.get(key) as AbstractControl;
      this.retiradaImediataControl.validator = control.validator;
    }
  }

  writeValue(value: boolean): void {
    if (value !== undefined && value !== null) {
      this.value = value;
      this.retiradaImediataControl.setValue(value);
    }
  }

  onChange?: (value: boolean) => void;
  onTouched?: () => void;

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
   this.disabled = isDisabled
  }
}
